<!--
 * @Author: your name
 * @Date: 2020-09-28 16:35:25
 * @LastEditTime: 2021-01-12 18:12:54
 * @LastEditors: wei ze min
 * @Description: 推广星飞帆新品页面
 * @FilePath: \xingmahui_front\src\views\activity\promotionMilk\index.vue
-->
<template>
  <div class="wrap">
    <div class="logo">
      <img src="./../../../assets/images/activity/A2/A2/logo.png" alt="">
    </div>
    <div class="head">
      <img src="./../../../assets/images/activity/A2/A2/A2_1.png" alt="">
    </div>
    
    
    <div class="videoWrap">
      <video src="https://image-mom.feihe.com/milkA2/milkA2.mp4" controls="controls" preload="none" poster="./../../../assets/images/activity/A2/A2/poster.jpg">
      您的浏览器不支持 video 标签。
      </video>
    </div>
    <!-- <div class="box1 mt10">
      <img v-show="!isShow1" style="height:285px"  src="https://image-mom.feihe.com/milkA2/gif1/1_00001.png" alt="">
      <canvas id="canvas" v-show="isShow1"></canvas>
    </div> -->
    <div class="box1 mt10">
      <img style="width:101%;" src="https://image-mom.feihe.com/milkA2/01.gif" alt="">
    </div>  

    <img src="./../../../assets/images/activity/A2/A2/3.jpg" alt="">

    <!-- <div class="box1">
      <img v-show="!isShow2"  style="height:350px" src="https://image-mom.feihe.com/milkA2/gif2/1_100001.png" alt="">
      <canvas id="canvas2" v-show="isShow2"></canvas>
    </div> -->

    <img src="https://image-mom.feihe.com/milkA2/02.gif" alt="">

    <div class="box2">
      <div class="niu">
        <img src="./../../../assets/images/activity/A2/A2/niu.gif" alt="">
      </div>

      <img src="./../../../assets/images/activity/A2/A2/A2_3.png" alt="">

    </div>


     <img src="https://image-mom.feihe.com/milkA2/04.gif" alt="">


    <img class="tip1" src="./../../../assets/images/activity/A2/A2/5.jpg" alt="">
         <img src="https://image-mom.feihe.com/milkA2/milkgif5.gif" alt=""> 
    <img class="tip2" src="./../../../assets/images/activity/A2/A2/6.jpg" alt="">
     <img src="https://image-mom.feihe.com/milkA2/06.gif" alt="">
    <img src="./../../../assets/images/activity/A2/A2/A2_6.png" alt="">

    <img src="./../../../assets/images/activity/A2/A2/8.jpg" alt="">
    <img src="./../../../assets/images/activity/A2/A2/A1_8.jpg" alt="">
    <img src="./../../../assets/images/activity/A2/A2/10.jpg" alt="">
    <img src="./../../../assets/images/activity/A2/A2/11.jpg" alt="">
    <img src="./../../../assets/images/activity/A2/A2/12.jpg" alt="">
    <img src="./../../../assets/images/activity/A2/A2/13.jpg" alt="">
    <img  class="temp" src="./../../../assets/images/activity/A2/A2/14.jpg" alt="">


    <img src="https://image-mom.feihe.com/milkA2/07.gif" alt="">
   
    <!-- <div class="box1">
      <img v-show="!isShow6" style="height:375px" src="https://image-mom.feihe.com/milkA2/gif7/4_00001.png" alt="">
      <canvas id="canvas6" v-show="isShow6"></canvas>
    </div> -->
    <img src="./../../../assets/images/activity/A2/A2/A2_13.png" alt="">
    <img src="./../../../assets/images/activity/A2/A2_9.gif" alt="">
  
  </div>
</template>

<style lang="less" scoped>
.mt10{
  margin-top: 5px;
}
.temp{
  margin-top: -2px;
  background: #fee07e;
  position: relative;
  bottom: -2px;
}
.box1{
  width: 100%;
}
.wrap {
  width: 100%;
  min-height: 100%;
  font-size: 0;
  background: #fee07e;
  overflow: hidden;

  .text {
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    padding-top: 300px;
  }
  img {
    width: 100%;
    height: auto;
  }
  .logo{
    padding: 18px 0 18px 14px;
    width: 140px;
    height: 23px;
  }
  .head{
    width: 100%;
    text-align: center;
    // padding-bottom: 20px;
    >img{
      width: 210px;
    }
  }
  .info1{
    width: 100%;
    text-align: center;
    padding-bottom: 10px;
    >img{
      width: 173px;
    }
  }
  .niu{
    position: absolute;
    top: 47%;
    right: 10.5%;
    width: 100px;
  }
}
.box2{
  position: relative;
  background: #fee07e;
  margin-top: -1px;
}
.videoWrap{
    // padding: 0 15px;
    margin: 20px auto 30px;
    width: 346px;
    // height: 187px;
    overflow: hidden;
    video{
      width: 346px;
      // height: 187px;
      border-radius: 5px;
    }
  }
.box{
  width: 100%;
  height: 100%;
}
.box{
  position: relative;
  background-repeat: no-repeat;
  background-size: cover;
}
.tip1{
  margin-bottom: -27px;
}
.tip2{
  margin-top: -15px;
}
.tip3{
  margin-top: -53px;
}

</style>

  

<script>
// 引入微信分享公共方法
import wxJsSet from './../../../assets/js/A2WxConfig.js'
// import FramePlayer from 'frame-player'
export default {
  name: "promotionMilk",
  components: {},
  data () {
    return {
      isShow1:false,
      isShow2:false,
      isShow3:false,
      isShow4:false,
      isShow5:false,
      isShow6:false
    };
  },
  computed: {},
  mounted () {
    const shareLink = window.location.origin + '/promotionMilk?pageFrom=share';
    const shareDataParams = {
      shareLink: shareLink,
      shareDesc: "星飞帆A2，来自北纬47度珍稀A2奶源，三重检测保障珍稀A2营养！",
      shareTitle: "天赐甄金-北纬47度珍稀A2奶源",
      imgUrl: "https://image-mom.feihe.com/wxshare/promotionMilk2.png",//必须是绝对路径
      shareSensorsFn: true
    };
    wxJsSet.wxShare(shareDataParams, this);
    if (this.$route.query.pageFrom) {
      sensors.track('ClickShareLink');  // 分享链接点击次数
    }
  },
  methods: {
    init(){

        // var canvas = document.getElementById("canvas");
        // this.drawCanvas(105,'gif1/1_0',canvas,285,'isShow1')

        // var canvas2 = document.getElementById("canvas2");
        // this.drawCanvas(205,'gif2/1_10',canvas2,350,'isShow2')

        // var canvas3 = document.getElementById("canvas3");
        // this.drawCanvas(105,'gif4/2_0',canvas3,375,'isShow3')

        // var canvas4 = document.getElementById("canvas4");
        // this.drawCanvas(90,'gif5/3_0',canvas4,300,'isShow4')

        // var canvas5 = document.getElementById("canvas5");
        // this.drawCanvas(105,'gif6/3_0',canvas5,225,'isShow5')
   
        // var canvas6 = document.getElementById("canvas6");
        // this.drawCanvas(105,'gif7/4_0',canvas6,375,'isShow6')

    },
    drawCanvas(num,img,canvas,h,show){
      var that = this
        var ticks = new Array(num)
        for (let i = 0; i < ticks.length; i++) {
           let imgName = ''
            const k = i + 1;
            if (k < 10) {
              imgName = `000${k}`
            } else if (k >= 10 && k < 100) {
              imgName = `00${k}`
            } else if (k >= 100 && k < 1000) {
              imgName = `0${k}`
            }
            ticks[i] = `https://image-mom.feihe.com/milkA2/`+ img +`${imgName}.png`
            
        }



        const frame = new FramePlayer({
          canvas: canvas,
          width: document.documentElement.clientWidth,
          height: h,
          fps: 24,
          loop: -1,
          transparent: true,
          autoPlay: true,
          images: ticks,
         
        })
        

        frame.on('play', function(){
          if(show === 'isShow1'){
            that.isShow1 = true;
          }else if(show === 'isShow2'){
            that.isShow2 = true;
          }else if(show === 'isShow3'){
            that.isShow3 = true;
          }else if(show === 'isShow4'){
            that.isShow4 = true;
          }else if(show === 'isShow5'){
            that.isShow5 = true;
          }else if(show === 'isShow6'){
            that.isShow6 = true;
          }
        })

 
    }
    
  }
}
</script>
